import styled from "styled-components";

type Props = {
  disabled?: boolean;
};

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  ${({ disabled }: Props) => {
    if (disabled) {
      return `
          button{
            background-color:#ccc;
            pointer-events:none;
          }
      `;
    }
  }}
`;
